import { zodResolver } from '@hookform/resolvers/zod'
import { Button, Grid, MenuItem, TextField } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { metodoPrograma } from '../../../components/api'

const createServico = z.object({
  cdServico: z.string(),
  idTipoAgendamento: z.number(),
})

export const EdicaoServico = ({
  setOpenModalServico,
  dados,
  getListaServicos,
  idTipoAgendamento,
}) => {
  const { register, handleSubmit, watch } = useForm({
    resolver: zodResolver(createServico),
    defaultValues: {
      cdServico: dados[0],
      idTipoAgendamento,
    },
  })
  const [listaServicos, setListaServicos] = useState([])
  const adicionaServico = (values) => {
    metodoPrograma('adicionaServico', values).then((res) => {
      if (res.status) {
        setOpenModalServico(false)
        getListaServicos()
      }
    })
  }

  const listarServicos = useCallback(() => {
    metodoPrograma('lista', {}, 'CtrlServico').then((res) => {
      if (res.status) {
        setListaServicos(res.lista)
      }
    })
  }, [])

  useEffect(() => {
    if (idTipoAgendamento) {
      listarServicos()
    }
  }, [idTipoAgendamento, listarServicos])

  return (
    <form onSubmit={handleSubmit(adicionaServico)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            {...register('cdServico')}
            value={watch('cdServico')}
            label="Código do Serviço"
            fullWidth
            variant="outlined"
            select
          >
            {listaServicos.map((item) => (
              <MenuItem key={item.cdServico} value={item[0]}>
                {item[0]} - {item[1]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} className="text-end">
          <Button type="submit" variant="contained" color="primary">
            Salvar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}
